// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__BUHsE","footer":"Form_footer__27khY"};